var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-wrapper',[_c('vs-text',[_vm._v("Unsupported field schema")]),(_vm.schema !== null)?_c('vs-text',[_vm._v(" schema: "),_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.schema, null, 2)))])]):_vm._e(),(_vm.uiSchema !== null)?_c('vs-text',[_vm._v(" uiSchema: "),_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.uiSchema, null, 2)))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }